<script lang="ts">
    import { getContext } from 'svelte'

    import Icon from '@iconify/svelte'

    import type { HydriaDocument } from 'hydria/HydriaDocument'
    import Modal from 'hydria/components/Modal.svelte'
    import TipTap from 'hydria/components/TipTapGen/index.svelte'
    import { type TGettext, gettext as _, resolve, tgettext } from 'hydria/services/gettext'

    interface Props {
        saved: string | undefined
        value: string | undefined
        disabled?: boolean
        showLabel?: boolean
        label?: any
        helpText?: TGettext | 'default'
        isValid?: any
        update?: (v: string | undefined) => void
        save?: (v: string | undefined) => void
    }

    let { saved: savedValue, value: inValue = $bindable(), disabled = false, showLabel = true, label = tgettext('Introduction'), helpText = $bindable('default'), isValid = (value: string | null | undefined) => true, update, save }: Props = $props()

    const Document = getContext('Document') as HydriaDocument

    // value in edition
    let value: string | undefined = $state()
    let preEditValue: string | undefined = $state()

    function load(lValue: string | undefined) {
        value = lValue
    }

    if (helpText === 'default') helpText = tgettext('Ce texte est affiché au début de la page. Ne pas oublier d’y inclure le titre principal.')

    let isOpen = $state(false)

    function keep() {
        // inValue = value
        if (update || save) {
            if (update) update(value)
            if (save) save(value)
        } else {
            inValue = value
        }
        // dispatch('save', currentValue)
        close()
    }

    function open() {
        value = inValue
        preEditValue = inValue
        isOpen = true
    }
    function close() {
        isOpen = false
    }

    let savedIsValid = $derived(isValid(savedValue))
    let isPristine = $derived(inValue == savedValue)

    let statusIcon: string = $derived.by(() => {
        if (isPristine) {
            return savedIsValid ? 'mdi:check-circle' : 'mdi:alert'
        } else if (isValid(inValue)) {
            return 'mdi:undo'
        } else {
            return 'mdi:undo'
        }
    })
    let statusClass: string = $derived.by(() => {
        if (isPristine) {
            return savedIsValid ? 'btn-link' : 'btn-danger'
        } else if (isValid(inValue)) {
            return 'btn-outline-warning'
        } else {
            return 'btn-outline-danger'
        }
    })
</script>

<div class="row g-3 align-items-baseline">
    {#if showLabel}
        <div class="col-2 text-end"><label aria-hidden="true" for="nothing" class="col-form-label" onclick={() => open()}>{$resolve(label)}</label></div>
    {/if}
    <div class="col">
        {#if isOpen}
            <Modal close={() => close()} keep={() => keep()} modalClasses="modal-xl">
                <div class="modal-header text-bg-primary">{$resolve(label)}</div>
                <div class="modal-body">
                    <TipTap
                        bind:value
                        {Document}
                        initialFocus={true}
                        onupdate={(v) => {
                            // value = v
                        }}
                    />
                    {#if helpText != null}
                        <div class="form-text">{$resolve(helpText)}</div>
                    {/if}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-outline-secondary" onclick={() => close()}>{$_('Fermer')}</button>
                    <button type="button" class="btn btn-sm btn-primary" disabled={!isValid(value) || value == inValue} onclick={() => keep()}>{$_('Appliquer')}</button>
                </div>
            </Modal>
        {/if}
        <div aria-hidden="true" ondblclick={() => open()} class="scheme scheme-display">
            {#if inValue && inValue != ''}
                {@html inValue}
            {:else}
                <em class="text-muted">{$_('non-configuré')}</em>
            {/if}
        </div>
        {#if helpText != null}
            <div class="form-text">{$resolve(helpText)}</div>
        {/if}
    </div>
    <div class="col-auto text-end">
        <button
            type="button"
            class="btn btn-sm {statusClass}"
            disabled={isPristine}
            onclick={() => {
                inValue = savedValue
            }}><Icon inline icon={statusIcon} /></button
        >
        <button type="button" class="btn btn-sm btn-outline-secondary" {disabled} onclick={() => open()}><Icon inline icon="mdi:edit" /></button>
    </div>
</div>
